import { render, staticRenderFns } from "./IssueResult.vue?vue&type=template&id=714fde39&"
import script from "./IssueResult.vue?vue&type=script&lang=js&"
export * from "./IssueResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports